import Snackbar from '@mui/joy/Snackbar';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import IconButton from '@mui/joy/IconButton';

const items = [
  { type: 'success', color: 'success', icon: <CheckCircleIcon /> },
  { type: 'warning', color: 'warning', icon: <WarningIcon /> },
  { type: 'error', color: 'danger', icon: <ReportIcon /> },
  { type: 'info', color: 'primary', icon: <InfoIcon /> },
];


export default function SnackbarMessage({ open, handleClose, text, type = 'info', autoHide = true }) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={autoHide ? 5000 : null}
      onClose={autoHide ? handleClose : undefined}
      style={{ zIndex: 9999 }}
      startDecorator={items.find(x => x.type === type).icon}
      endDecorator={
        <IconButton variant="soft" color={items.find(x => x.type === type).color} onClick={handleClose}>
          <CloseRoundedIcon />
        </IconButton>
      }
      color={items.find(x => x.type === type).color}
      variant='soft'
      invertedColors
    >
      {text}
    </Snackbar>
  );
}
